import React from 'react';

import { SearchBox } from 'react-instantsearch-dom';

const Submit = (
    <img src="https://img.icons8.com/material-rounded/48/000000/search.png" alt="" />
);

const Reset = (
    <img src="https://img.icons8.com/material-rounded/48/000000/recurring-appointment.png" alt="" />
);

const SearchField = () => (
    <SearchBox
        className="search-field"
        searchAsYouType={true}
        showLoadingIndicator={false}
        submit={Submit}
        reset={Reset}
        translations={{
            submitTitle: 'Zoeken',
            resetTitle: 'Reset',
            placeholder: 'Zoeken',
        }}
    />
);

export { SearchField };
